import { createContext } from 'react';

export const FilesContext = createContext({});